//bootstrap
import { Button, Spinner } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setStatusLogin, selectStatusLogin } from "../../../redux/reducer/user/userSlice";

//----------------------------------------------------------

export default function LoginSubmit({ formik }: any) {
    //redux
    const dispatch = useAppDispatch();
    const status = useAppSelector(selectStatusLogin);

    //function
    const switchButtons = () => {
        switch (status) {
            case "init": {
                return (
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                    >
                        Sign in
                    </Button>
                );
            }
            case "load": {
                return (
                    <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                        <span className="visually-hidden">Loading...</span>
                    </Button>
                );
            }
            case "success": {
                return (
                    <Button
                        variant="success"
                        size="lg"
                        onClick={() => {
                            window.location.reload();
                        }}
                    >
                        Sing out
                    </Button>
                );
            }
            case "unsuccess": {
                return (
                    <Button
                        variant="warning"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusLogin("init"));
                        }}
                    >
                        Login unabled
                    </Button>
                );
            }
            case "failed": {
                return (
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={() => {
                            dispatch(setStatusLogin("init"));
                        }}
                    >
                        Connecion unable
                    </Button>
                );
            }
            default: {
            }
        }
    };

    //view
    return <>{switchButtons()}</>;
}
